import React, { useEffect, useState } from "react";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function Promotions() {
  const { trackAndGo } = useSite();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/content/promotions?published_only=true").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const now = new Date();
  const active = items.filter((p) => !p.end_date || new Date(p.end_date) >= now);

  return (
    <div>
      <PageHero overline="Offers" title="Promotions & Campaigns" subtitle="Time-bound offers for new and existing clients, managed from our CMS." />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container">
          {active.length === 0 ? (
            <p className="text-slate-500">There are no active promotions right now. Please check back soon.</p>
          ) : (
            <div className="grid md:grid-cols-2 gap-6">
              {active.map((p) => (
                <div key={p.id} className="cb-card p-8 flex flex-col" data-testid={`promotions-item-${p.id}`}>
                  {p.badge && <span className="overline mb-3">{p.badge}</span>}
                  <h3 className="font-serif text-2xl text-[#0B1D40] mb-2">{p.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed flex-1">{p.description}</p>
                  {p.end_date && <p className="text-xs text-slate-500 mt-4 font-mono">Ends {new Date(p.end_date).toLocaleDateString()}</p>}
                  <button onClick={() => trackAndGo(p.link_key || "live_register")} className="btn-gold px-6 py-3 text-sm mt-5 self-start" data-testid={`promotions-claim-${p.id}`}>Claim Offer</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
